import React from "react";

function FichesSocietes() {
  const pictoFiche = (
    <svg
      id="Calque_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 11.6 16.1"
      style={{ enableBackground: "new 0 0 11.6 16.1", width: "19px", height: "19px", paddingRight: "10px" }}
      xmlSpace="preserve"
    >
      <path
        fill="#ffffff"
        d="M10.3,3.1H8.6V1.3C8.6,1.1,8.5,1,8.3,1C8.2,1,8,1.1,8,1.3v2.1c0,0.2,0.1,0.3,0.3,0.3h2c0.2,0,0.3-0.1,0.3-0.3S10.5,3.1,10.3,3.1z"
      />
      <path
        fill="#005344"
        d="M11,3L8.6,0.8C8.5,0.7,8.4,0.6,8.2,0.6H1.6c-0.6,0-1,0.4-1.1,1v12.9c0,0.6,0.5,1.1,1.1,1.1H10c0.6,0,1.1-0.5,1.1-1.1h0.1V3.4C11.2,3.2,11.1,3.1,11,3z M10.3,3.7h-2C8.1,3.7,8,3.6,8,3.4V1.3C8,1.1,8.2,1,8.3,1c0.2,0,0.3,0.1,0.3,0.3v1.8h1.7c0.2,0,0.3,0.1,0.3,0.3S10.5,3.7,10.3,3.7z"
      />
    </svg>
  );

  return (
    <div className="fiches-container-main" id="fiches-societes">
      <div className="fiches-cardTitle">Sociétés</div>
      <ul className="fiches-blockList">
        <div className="fiches-listElem fiches-listElem--disabled" title="PDF non disponible">
          {pictoFiche}
          Dissolution et partage de société
        </div>
        <div className="fiches-listElem fiches-listElem--disabled" title="PDF non disponible">
          {pictoFiche}
          Cessions de droits sociaux
        </div>
        <div className="fiches-listElem fiches-listElem--disabled" title="PDF non disponible">
          {pictoFiche}
          ...
        </div>
      </ul>
    </div>
  );
}

export default FichesSocietes;
